import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class TierDropdownLookup extends ValueObject {
    public tierId: number = 0;

    public tierName: string = "";

    public deletedInd: boolean = false;
}